import React from 'react';
import { connect } from 'react-redux';
import { DBDecimalFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationCircumferenceIP extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Circumference - IP' />
                    <label className={styles.label}>IP</label>
                </div>
                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel_indent}>Thumb</label>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRIPTHUMBR'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                    <span className={styles.circum_column}>
                        <DBDecimalFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEOBS'
                            entityKeyColumn='OONO'
                            entityKeyValue={this.props.oono}
                            field='OOCIRIPTHUMBL'
                            className={styles.circum_input}
                            min={0}
                        />
                    </span>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged:
            (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRIPTHUMBR !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRIPTHUMBR !== null)
                || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRIPTHUMBL !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCIRIPTHUMBL !== null)
                ? true : false
    };
}

const connectedObservationCircumferenceIP = connect(mapStateToProps)(ObservationCircumferenceIP);
export { connectedObservationCircumferenceIP as ObservationCircumferenceIP };


